export const newsList = [
  {
    id: 1,
    title: "《星海旅人》第二季确定制作，主视觉图公开",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20news%20illustration%20of%20a%20space%20crew%20silhouetted%20in%20front%20of%20a%20glowing%20nebula%20window%2C%20navy%20and%20orange%20palette%2C%20clean%20wide%20composition%20with%20soft%20light%20rays%2C%20cinematic%20anime%20key%20art%20style&width=900&height=560&seq=anime-news-01&orientation=landscape",
    date: "2026-10-16",
    category: "动画新番",
    tags: ["星海旅人", "科幻"],
    excerpt:
      "官方于今日正式宣布《星海旅人》第二季进入制作阶段，并公开了一张以「白鲸号」为主体的主视觉图。第二季将延续第一季结尾的静默带航线。",
    content: [
      "在昨日结束的线上发表会中，动画《星海旅人》的制作方宣布第二季正式进入制作阶段。发表会同时公开了首张主视觉图，画面中「白鲸号」飞船停在静默带的边缘，背景是尚未被记录过的星云。",
      "监督青木遥在访谈中提到，第二季的核心问题将从「星图为什么消失」转向「谁有权力决定一段历史被记录」。第一季中仅以广播形式出现的殖民船残骸，会在新一季成为重要场景。",
      "制作组表示，第二季将继续沿用第一季的手绘赛璐璐风格，并增加宇宙空间的长镜头表现。目前官方未公布具体播出时间，仅透露配音阵容将保持原班人马。",
    ],
    author: "编辑部",
  },
  {
    id: 2,
    title: "2026 秋季新番前瞻：这十部作品值得加入追番列表",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20editorial%20illustration%20of%20a%20grid%20of%20colorful%20anime%20poster%20cards%20floating%20on%20a%20warm%20cream%20background%2C%20soft%20shadows%2C%20orange%20and%20charcoal%20accents%2C%20clean%20modern%20magazine%20layout%20aesthetic&width=900&height=560&seq=anime-news-02&orientation=landscape",
    date: "2026-10-14",
    category: "专题",
    tags: ["新番", "片单"],
    excerpt:
      "秋季档已经进入第二个月，我们整理了十部在作画、叙事和音乐上都有亮点的作品，涵盖科幻、治愈、悬疑与运动题材。",
    content: [
      "每一季的新番数量都在增加，真正值得追的作品反而更难被看见。这次的秋季前瞻，编辑部从已经播出的集数出发，挑选了十部在叙事节奏和作画稳定性上表现突出的作品。",
      "科幻方面，《星海旅人》第二季与《终末列车》是两种完全不同的方向：前者把镜头对准宇宙的辽阔，后者则把空间压缩进一节车厢。喜欢慢节奏的观众，可以尝试《深夜拉面店》导演的新作。",
      "悬疑档的竞争最激烈，《迷宫的第七封信》凭借密闭空间的高密度对话获得了本季最高的讨论度。如果你更偏爱运动题材，《灼热篮筐》的第五集值得单独拿出来看一遍。",
      "最后提醒一句：追番不必贪多。找到一两部真正想每周等更新的作品，比把整季列表全部收藏更实际。",
    ],
    author: "苏木",
  },
  {
    id: 3,
    title: "《迷宫的第七封信》第 8 集剧情解析：那封从未寄出的信",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20atmospheric%20illustration%20of%20an%20empty%20library%20room%20with%20six%20letters%20spread%20across%20a%20wooden%20table%2C%20cold%20moonlight%20through%20a%20tall%20window%2C%20dust%20particles%2C%20muted%20teal%20and%20brown%20tones%2C%20suspenseful%20composition&width=900&height=560&seq=anime-news-03&orientation=landscape",
    date: "2026-10-12",
    category: "剧情解析",
    tags: ["迷宫的第七封信", "悬疑"],
    excerpt:
      "第 8 集用一个长达四分钟的静止镜头，把前七集建立的所有信任全部推翻。以下内容包含剧透，请谨慎阅读。",
    content: [
      "警告：本文包含《迷宫的第七封信》第 8 集的完整剧透。",
      "第 8 集开场，镜头停在旧书店二层的书桌上，六封信按拆开的顺序排成一列。整整四分钟里，画面几乎没有变化，只有窗外的雨声和楼下翻书的声音。这种处理方式看起来在拖时间，实际上把观众放进了和角色完全相同的处境：被困在一个不能离开的房间里，只能靠对话推理。",
      "本集最关键的信息不是第七封信的内容，而是信封上的笔迹。制作组在前七集里多次给出笔迹特写，第 8 集回收了其中三处。当第四个角色说出「这封信不是写给我的」时，前面所有看似善意的举动都被重新解读。",
      "值得注意的是，本集没有给出凶手的名字，只让房间里的灯灭了一次。监督白石凉在采访中表示，最终答案会在第 11 集揭晓，而第 9 集会从另一个人的视角重讲同一个夜晚。",
    ],
    author: "推理组",
  },
  {
    id: 4,
    title: "《机械纪元 2077》幕后访谈：如何打造一座会呼吸的赛博都市",
    cover:
      "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20anime%20style%20illustration%20of%20an%20animation%20studio%20desk%20covered%20with%20mecha%20concept%20design%20sheets%2C%20monitors%20showing%20wireframe%20city%20layouts%2C%20warm%20desk%20lamps%2C%20orange%20and%20teal%20accent%20lighting%2C%20clean%20detailed%20background%20art&width=900&height=560&seq=anime-news-04&orientation=landscape",
    date: "2026-10-10",
    category: "制作访谈",
    tags: ["机械纪元 2077", "机甲"],
    excerpt:
      "从一块显示面板开始，Northline Studio 用两年时间搭建了新港市。我们和美术监督聊了聊机械质感与城市尺度。",
    content: [
      "《机械纪元 2077》最令人印象深刻的不是机体战斗，而是城市本身。街道会在夜里缓慢改变宽度，路灯按照人流量调节亮度，这些细节并非装饰，而是剧情的一部分。",
      "美术监督 Evan Cole 提到，团队最初做了一版非常「未来感」的设计，全是玻璃和悬浮结构，后来被全部推翻。「我们想要的城市不是更亮，而是更旧。它应该像一台被人用了三十年的机器，每个角落都有维修痕迹。」",
      "为了让城市在画面中保持可信，团队建立了统一的尺度表：一层楼多高、一条车道多宽、机体的脚掌有多大。所有镜头都必须按照这张表计算，包括那些只出现两秒的远景。",
      "关于第二季，Cole 只透露了一句：「母体的设计图我们早就画完了，观众现在看到的只是它的一层皮。」",
    ],
    author: "李澈",
  },
  {
    id: 5,
    title: "国产动画《妖怪町的夏天》宣布剧场版，原班人马回归",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20festive%20illustration%20of%20a%20summer%20night%20street%20with%20red%20paper%20lanterns%20and%20small%20spirits%2C%20warm%20orange%20glow%2C%20distant%20fireworks%20above%20tiled%20rooftops%2C%20celebratory%20mood%2C%20rich%20cel%20shaded%20background%20art&width=900&height=560&seq=anime-news-05&orientation=landscape",
    date: "2026-10-08",
    category: "行业动态",
    tags: ["妖怪町的夏天", "国产动画"],
    excerpt:
      "剧场版将讲述电视版之前的故事，聚焦外婆年轻时经营旅馆的第一年。原班配音与制作团队确认回归。",
    content: [
      "《妖怪町的夏天》官方今日宣布剧场版动画企划启动，预计 2027 年上映。与电视版不同，剧场版将时间线往前推四十年，讲述外婆年轻时第一次接手旅馆的那个夏天。",
      "导演陈屿表示，电视版讲的是「如何送走客人」，剧场版想讲的是「如何留下」。他同时确认，电视版的配音演员将以回忆或旁白的形式参与剧场版。",
      "制作方山海绘社透露，剧场版会保留电视版的手绘质感，但在夏日祭的场景中加入更复杂的群像调度，单是祭典主街的一个镜头就绘制了超过两百张原画。",
    ],
    author: "编辑部",
  },
  {
    id: 6,
    title: "经典重制：十部值得重温的高分治愈系动画",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20anime%20style%20illustration%20of%20a%20quiet%20afternoon%20cafe%20interior%20with%20sunlight%20through%20lace%20curtains%2C%20a%20cup%20of%20tea%20and%20an%20open%20book%20on%20a%20wooden%20table%2C%20plants%20and%20soft%20cream%20tones%2C%20nostalgic%20peaceful%20mood&width=900&height=560&seq=anime-news-06&orientation=landscape",
    date: "2026-10-05",
    category: "片单推荐",
    tags: ["治愈", "片单"],
    excerpt:
      "治愈系不是没有冲突，而是把冲突放在生活里慢慢化解。这份片单里的十部作品，适合在深夜一个人看完。",
    content: [
      "很多人把治愈系理解成「没有压力的故事」，其实真正好的治愈作品往往直面困境，只是它们选择用日常的方式处理。",
      "《深夜拉面店》是近几年最典型的例子：每集都在讲一个具体的难题，失业、离别、无法开口的道歉，但它从不给出奇迹般的解决方案，只让人坐下来吃完一碗面。",
      "如果你更喜欢安静的画面，《猫与咖啡与雨天》和《钢琴与少年》值得放进列表。前者用雨天串起一段关系的全部细节，后者则把「听不见」变成一种重新理解声音的方式。",
      "这份片单没有排名，因为治愈本来就不需要比较。挑一部你此刻最想看的就好。",
    ],
    author: "苏木",
  },
  {
    id: 7,
    title: "《剑焰之誓》作画特辑：一镜到底的火焰决斗是这样做成的",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20fiery%20sword%20clash%20between%20two%20silhouetted%20warriors%2C%20sparks%20and%20embers%20flying%20across%20a%20dark%20stone%20courtyard%2C%20intense%20orange%20glow%2C%20dynamic%20motion%20lines%2C%20dramatic%20action%20key%20frame&width=900&height=560&seq=anime-news-07&orientation=landscape",
    date: "2026-10-02",
    category: "制作访谈",
    tags: ["剑焰之誓", "作画"],
    excerpt:
      "第 6 集那段 42 秒的连续镜头由 9 位原画师接力完成。我们拆解了它的分镜结构与火焰特效处理方式。",
    content: [
      "《剑焰之誓》第 6 集播出后，那段长达 42 秒的连续决斗镜头迅速成为讨论焦点。镜头从庭院地面起，跟随伊织的刀锋绕过三根木柱，最后停在对手的眼睛上，全程没有剪辑点。",
      "作画监督桐生一真解释，这段镜头并不是真的一镜到底，而是由 9 位原画师分工完成，通过精确的对位线拼接。「最难的不是动作，是火焰。每一段火焰的形状必须接得上，否则观众立刻会看出断点。」",
      "团队最终采用了「先画刀光，再补火」的流程：所有关键帧先以白线完成动作逻辑，确认衔接无误后才加入燃烧效果与飞散的余烬。",
      "这段镜头从分镜到完成共耗时三个月，其中有两个星期只用于修正第 17 秒到第 21 秒之间的空间关系。",
    ],
    author: "作画研究室",
  },
  {
    id: 8,
    title: "声优阵容公布：《春日告白委员会》迎来新角色登场",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20four%20high%20school%20club%20members%20standing%20in%20a%20bright%20classroom%2C%20colorful%20character%20designs%2C%20warm%20spring%20sunlight%2C%20clean%20pastel%20background%20with%20chalkboard%2C%20cheerful%20slice%20of%20life%20anime%20key%20visual&width=900&height=560&seq=anime-news-08&orientation=landscape",
    date: "2026-09-28",
    category: "动画新番",
    tags: ["春日告白委员会", "恋爱"],
    excerpt:
      "官方公开了告白委员会第五位成员的角色设定与声优，新角色将在第 12 集正式登场，与林知夏有一段关键的对手戏。",
    content: [
      "《春日告白委员会》官方今日公布新角色「季明澄」的角色设定图，并确认由新生代声优担任配音。这个角色将在第 12 集登场，身份是委员会最早的四位成员之一。",
      "角色设定中，季明澄总是穿着不合身的校服外套，随身携带一本写满便签的笔记本。监督苏晚表示，这个角色的加入会解释前面十一集里所有「缺席」的伏笔。",
      "官方同时公开了一段 30 秒的预告，画面中没有出现台词，只有林知夏推开社团教室门的声音。第 12 集将于下周三更新。",
    ],
    author: "编辑部",
  },
  {
    id: 9,
    title: "动画音乐盘点：那些让人单曲循环的 OP 与 ED",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20headphones%20resting%20on%20a%20music%20score%20beside%20a%20glowing%20phone%20screen%2C%20warm%20night%20desk%20scene%20with%20soft%20lamp%20light%2C%20orange%20and%20charcoal%20tones%2C%20clean%20editorial%20anime%20aesthetic&width=900&height=560&seq=anime-news-09&orientation=landscape",
    date: "2026-09-24",
    category: "专题",
    tags: ["音乐", "OP", "ED"],
    excerpt:
      "一首好的主题曲能把观众的回忆钉在某个具体的夏天。这次我们盘点了近两年最常被单曲循环的动画歌曲。",
    content: [
      "动画主题曲的特殊之处在于，它必须在 90 秒里同时完成两件事：介绍故事的气质，以及让人愿意再听一遍。",
      "《钢琴与少年》的 ED 几乎没有鼓点，只有钢琴与一段呼吸般的人声，配合每集结尾不同的静止画面，成为很多观众心中最难跳过的片尾。",
      "《终末列车》的 OP 走了完全相反的方向，用近乎噪音的吉他墙把末世的失重感推到极致。有意思的是，这首歌在第 6 集被用作了插曲，编曲换成了八音盒版本，情绪完全翻转。",
      "音乐不会改变剧情，但它决定了我们记住剧情的方式。这大概就是为什么多年以后，我们还能哼出某部动画的前奏。",
    ],
    author: "李澈",
  },
];